<template>
  <el-dialog
    :title="$t('mappingDomain.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center">
      <p>{{ $t('mappingDomain.confirmDeleteConfig') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('mappingDomain.cancelDelete') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('mappingDomain.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMappingDomain } from '@/api/dev/mappingDomainApi'

export default {
  name: 'DeleteMappingDomain',
  data() {
    return {
      dialogVisible: false,
      currentItem: {}
    }
  },
  methods: {
    open(data) {
      this.currentItem = { ...data }
      this.dialogVisible = true
    },
    handleClose() {
      this.currentItem = {}
    },
    async handleConfirm() {
      try {
        await deleteMappingDomain(this.currentItem)
        this.$message.success(this.$t('mappingDomain.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>